import { render } from "./AboutModal.vue?vue&type=template&id=04d5472a&scoped=true&ts=true"
import script from "./AboutModal.vue?vue&type=script&lang=ts"
export * from "./AboutModal.vue?vue&type=script&lang=ts"

import "./AboutModal.vue?vue&type=style&index=0&id=04d5472a&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d5472a"]])

export default __exports__